// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"795b9446","911":"527921bd","1051":"cf71bbe4","2576":"527921bd","3053":"527921bd","6124":"c8f76dae","6589":"9efe3034","9250":"01ea82c1"}[chunkId] + ".chunk.css";
};